import React, { Component } from 'react';
import './TextFullImage.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';

class TextFullImage extends Component {

  componentDidMount(){
    AOS.init({
      duration : 1200,
      disable: 'mobile'
    })
  }

  render() {
    return (
      <div className={`d-flex align-items-center textfullimage ${this.props.classes}`}>
        <div className="content-wrapper container-fluid">
          <div className="row d-flex align-items-center mt-5">
            <div data-aos='fade-up' data-aos-delay="500" className={`col-12 standard-padding`}>
              <h2 className="textQuote text-center" dangerouslySetInnerHTML={{__html: this.props.title}}/>
              <hr className="black"/>
              {
                this.props.paragraphs.map( paragraph => {
                  return(
                    <p className="mt-5 grey" dangerouslySetInnerHTML={{__html: paragraph}}>
                    </p>
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default TextFullImage;
